module.exports = __webpack_public_path__ + "static/img/11.057b0be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fg/11.png
// module id = 128
// module chunks = 2